export const firebaseConfig={
  apiKey: "AIzaSyBUW08IeVYtA9VW4t1XUCecQrXufs1EUjg",
  authDomain: "your-styles.firebaseapp.com",
  databaseURL: "https://your-styles.firebaseio.com",
  projectId: "your-styles",
  storageBucket: "your-styles.appspot.com",
  messagingSenderId: "1056603338379",
  appId: "1:1056603338379:web:6577fab0f8d3b8d585868e",
  measurementId: "G-ZG9XT6K296"
};
